module.exports = __webpack_public_path__ + "img/icon-company-active.49c000a3.png";